module.exports = __webpack_public_path__ + "img/ZAtop-SM160-40B-side.bc596cd8.jpg";